import { ApiFactory, type ApiSocialDataResponse } from '@/utils/api';
import type { NewUserThisMonthReq, NewUser } from '@/models/interface/social';

const baseUrl: string = import.meta.env.VITE_SOCIALCAMPUS_URL;

export class SocialService extends ApiFactory {
  constructor() {
    super(`${baseUrl}/users`);
  }

  getNewUserThisMonth(param: NewUserThisMonthReq): Promise<ApiSocialDataResponse<NewUser[]>> {
    return super.get('newUserThisMonth', param, {
      headers: {
        disableGlobalLoading: true
      }
    });
  }
}
